import React from 'react';

import { MCButton, MCText, PopoverMenu, View } from 'src/components/basic';
import { MediaGroup, Map, popupModel } from 'src/components/complex';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import {
  scssVariables as variables,
  remCss,
  lang,
  rgba,
  scssVariables,
  addressObject,
  userFullName,
  upperFirstChar
} from 'src/helpers';

import ShortInfo from 'src/components/user/ShortInfo';
import constants from 'src/constants';
import { activeModel, pendingModel } from './model';
import CertificateDetail from 'src/components/user/CertificateDetail';
import AcceptDeclineForm from 'src/components/user/AcceptDeclineForm';
import AlertManager from 'src/components/alert/AlertManager';
import moment from 'moment/moment';

const userStatuses = constants.general.userStatus;
export default class Item extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expand: false,
      hospitals: null
    };
  }

  renderCenter() {
    const { item } = this.props;
    let images = item.images || [];
    return (
      <div className={'mc-content-left mc-grow'} style={{ width: 'auto' }}>
        {images.length > 0 && (
          <div className={'mc-flex'} style={{ maxWidth: remCss(380) }}>
            <MediaGroup images={images} />
          </div>
        )}
        <div className={'mc-value-622 mc-mt20'}>{userFullName(item)}</div>
        <div className={'mc-tag-group'}>
          {constants.general.specialist
            .filter((i) => item.specialist?.indexOf(i.value) > -1)
            .map((tag) => (
              <div className={'mc-tag'} key={'tag-' + tag.value}>
                {lang.t(tag.label)}
              </div>
            ))}
        </div>
        <pre className={'mc-label-418 mc-mb20'} style={{ lineHeight: remCss(24) + 'px' }}>
          {item.description}
        </pre>
        {item.treatments?.length > 0 && (
          <div className={'mc-box'}>
            <div className={'mc-title'}>{lang.t('Treatments')}</div>
            {item.treatments.map((item, i) => (
              <div className={'mc-flex'} key={i}>
                <div className={'mc-label'}>{item.name || item.title}</div>
                <div className={'mc-value'}>${item.fee || item.amount}</div>
              </div>
            ))}
          </div>
        )}
        {item.certificateFiles?.length > 0 && (
          <div className={'mc-box mc-flex-15-col'}>
            <div className={'mc-title'}>{lang.t('Certificates')}</div>
            <div className={'mc-flex-15 mc-flex-start mc-wrap'}>
              {item.certificateFiles?.map((file, index) => (
                <CertificateDetail
                  key={index}
                  item={file}
                  index={index}
                  certificateFiles={item.certificateFiles}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }

  renderRight() {
    const { hospitals = [] } = this.state;

    return (
      <div className={'mc-content-right'}>
        <div className={'mc-box'}>
          <div className={'mc-flex-col'}>
            <div className={'mc-title'}>{lang.t('Clinic / Hospital')}</div>
            {hospitals?.map((h) => {
              const hospitalAddress = [
                h.hospital?.split('_')[0],
                addressObject({ cityAddress: h.city }).fullAddressNameReverse
              ]
                .filter((v) => !!v)
                .join(', ');

              return (
                <React.Fragment key={h.id}>
                  <div className={'mc-label'}>{hospitalAddress}</div>
                  <Map addressString={hospitalAddress} geocode={true} width={300} height={300} />
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  render() {
    let { item, index } = this.props;

    return (
      <div
        className={'mc-flex-col mc-ptb15 mc-plr10 mc-mlr30 '}
        style={{
          backgroundColor:
            index % 2 === 0
              ? rgba(scssVariables['colors-mc-primary'], 0.08)
              : scssVariables['colors-mc-white']
        }}
      >
        <div className={'mc-flex'}>
          <div className={'mc-flex-col mc-grow'} style={{ minWidth: 0 }}>
            <ShortInfo
              user={item}
              large
              description={item.email}
              styleName={item.status !== userStatuses.pending ? { flex: 1, maxWidth: 150 } : null}
              badges={
                item.status !== userStatuses.pending && (
                  <MCText
                    primary={item.status === userStatuses.updated}
                    secondary={item.status !== userStatuses.updated}
                    size={18}
                    label={upperFirstChar(item.status)}
                  />
                )
              }
            />
          </div>
          <div className={'mc-flex'}>
            <MCText
              style={{ textAlign: 'right', paddingRight: 30 }}
              label={moment(item.updated || item.created).calendar({
                sameDay: 'ddd MM.YYYY[\n]HH:mm',
                lastDay: 'ddd MM.YYYY[\n]HH:mm',
                lastWeek: 'ddd MM.YYYY[\n]HH:mm',
                sameElse: () => {
                  return 'DD.MM.YYYY[\n]HH:mm';
                }
              })}
            />
            <MCButton
              light
              primary
              medium
              radius
              style={{ width: remCss(123) }}
              onClick={() =>
                popupModel.setActivePopup('accept_decline_form', {
                  active: true,
                  component: AcceptDeclineForm,
                  props: {
                    item,
                    actionStatus: userStatuses.approved,
                    model: pendingModel,
                    afterApproved: () => {
                      activeModel.setListStateSilent({ items: [] });
                      activeModel.loadMore();
                    }
                  }
                })
              }
            >
              {lang.t('Accept')}
            </MCButton>
            <MCButton
              light
              secondary
              medium
              radius
              style={{ width: remCss(123) }}
              onClick={() =>
                popupModel.setActivePopup('accept_decline_form', {
                  active: true,
                  component: AcceptDeclineForm,
                  props: {
                    item,
                    actionStatus: userStatuses.declined,
                    model: pendingModel
                  }
                })
              }
            >
              {lang.t(item.status === userStatuses.pending ? 'Decline' : 'More info')}
            </MCButton>

            <View>
              <PopoverMenu
                placement={'bottom-end'}
                triggerOffset={0}
                menu={() => (
                  <ul
                    className={'mc-select-field-items'}
                    style={{
                      backgroundColor: 'white',
                      padding: remCss(10)
                    }}
                  >
                    <li>
                      <MCButton
                        iconname={BASE_ICONS.CLOSE}
                        width={48}
                        padding={7}
                        light
                        radius
                        secondary
                        onClick={() =>
                          AlertManager.popup(AlertManager.TYPES.WARN, {
                            close: false,
                            title: 'Are you sure want to delete?',
                            cancelButton: {
                              label: 'No',
                              action: (actions) => actions.hide()
                            },
                            actionButton: {
                              label: 'Yes',
                              loadingLabel: 'Deleting',
                              action: (actions) => {
                                actions.setLoading(true);
                                pendingModel.remove(item.id, (err, res, success) => {
                                  actions.setLoading(false);
                                  if (success) {
                                    actions.hide();
                                  } else {
                                    alert(`error: ${err}`);
                                  }
                                });
                              }
                            }
                          })
                        }
                      />
                    </li>
                  </ul>
                )}
                className={'mc-no-style-btn'}
              >
                {() => <SVGIcon iconname={BASE_ICONS.DOTS} width={44} padding={7} />}
              </PopoverMenu>
            </View>
            <MCButton
              onClick={() => {
                this.setState({ expand: !this.state.expand });
                if (this.state.hospitals === null)
                  pendingModel.loadHospitals(this.props.item.id, ({ hospitals }) =>
                    this.setState({ hospitals })
                  );
              }}
              tiny
              primary
              light
              radius
            >
              <span
                className={'mc-rotate ' + (this.state.expand ? 'mc-rotate-180' : '')}
                style={{ height: remCss(44) }}
              >
                <SVGIcon
                  iconname={BASE_ICONS.DOWN}
                  width={44}
                  padding={5}
                  fill={variables['colors-mc-primary']}
                />
              </span>
            </MCButton>
          </div>
        </div>
        <div className={'mc-doctor-detail-page ' + (this.state.expand ? '' : 'mc-hide')}>
          {this.renderCenter()}
          {this.renderRight()}
        </div>
      </div>
    );
  }
}
